import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import {
  contractingActivityKeys,
  contractingKeys,
  contractingTaskKeys,
} from "@/lib/query-keys";

/** Toda tarea cambia el badge del tablero y el historial de su licitación. */
function useTaskInvalidation() {
  const qc = useQueryClient();
  return (contractingId?: number) => {
    qc.invalidateQueries({ queryKey: contractingTaskKeys.all });
    qc.invalidateQueries({ queryKey: contractingKeys.lists() });
    if (contractingId != null) {
      qc.invalidateQueries({
        queryKey: contractingActivityKeys.timeline(contractingId),
      });
    }
  };
}

export function useCreateTask() {
  const invalidate = useTaskInvalidation();
  return useMutation({
    mutationFn: (vars: {
      contracting_id: number;
      title: string;
      assigned_user_id?: string;
    }) =>
      fetchToBackend("/contractingtasks", {
        method: "POST",
        body: JSON.stringify(vars),
      }),
    onSuccess: (_d, vars) => invalidate(vars.contracting_id),
  });
}

export function useSetTaskDone() {
  const invalidate = useTaskInvalidation();
  return useMutation({
    mutationFn: (vars: { id: number; done: boolean; contracting_id?: number }) =>
      fetchToBackend(`/contractingtasks/${vars.id}/done`, {
        method: "POST",
        body: JSON.stringify({ done: vars.done }),
      }),
    onSuccess: (_d, vars) => invalidate(vars.contracting_id),
  });
}

export function useDeleteTask() {
  const invalidate = useTaskInvalidation();
  return useMutation({
    mutationFn: (vars: { id: number; contracting_id?: number }) =>
      fetchToBackend(`/contractingtasks/${vars.id}`, { method: "DELETE" }),
    onSuccess: (_d, vars) => invalidate(vars.contracting_id),
  });
}
